module.exports = __webpack_public_path__ + "img/30.43aa14a7.jpg";